import { resolveIconWidth, splitCamelCaseAndUpperCase } from "@/Settings/helpers/SystemSettings/appendingConfiguration";
import Title from "../../../common/Title";
import { IGlAccount, IRow, IWSGroup } from "@/Settings/types/SystemSettings/appendingConfiguration";
import { Grid, Stack } from "@mui/material";
import { IAppendingConfigurationFranchise, IAppendingConfigurationOems } from "@/Settings/types/Common/model";
import { iconsMap } from "@/Constants/iconsMap";
import AppendingConfigurationTable from "./AppendingConfigurationTable";

const getIcon = (franchise: string) => {
	const lowerFranchise = (franchise || "").toLowerCase();
	return iconsMap[lowerFranchise];
};

const IconContainer = ({ configurationItem }: { configurationItem: IAppendingConfigurationFranchise }) => {
	return (
		<div style={{ height: 50, width: 450 }}>
			{configurationItem?.isCombined ? (
				<Stack direction="row" height={50}>
					{configurationItem?.groups?.map((groupItem, index) => (
						<img
							key={groupItem.franchiseName}
							alt={groupItem.franchiseName}
							src={getIcon(groupItem.franchiseName)}
							width={resolveIconWidth(groupItem.franchiseName)}
							style={index !== (configurationItem?.groups?.length ?? 0 - 1) ? { marginRight: 10 } : undefined}
						/>
					))}
				</Stack>
			) : (
				<Stack direction="row" height={50}>
					<img
						alt={configurationItem?.franchise}
						src={getIcon(configurationItem?.franchise)}
						width={resolveIconWidth(configurationItem.franchise)}
					/>
				</Stack>
			)}
		</div>
	);
};

type TAppendingConfigFranchisesSectionProps = {
	reference: string;
	oems: IAppendingConfigurationOems[];
	wsGroups: IWSGroup[];
	resolveGlAccounts: () => { allSelectableGlAccounts: IGlAccount[]; filteredGlAccounts: IGlAccount[] };
	onSaveConfiguration: (data: { finalRow?: IRow; reference: string; franchise?: string | null }) => Promise<void>;
	onRemoveConfiguration: (ids: string[]) => Promise<void>;
	onMultipleSaveConfiguration: (rows: IRow[]) => Promise<void>;
	isPending: boolean;
};

const AppendingConfigFranchisesSection = (props: TAppendingConfigFranchisesSectionProps) => {
	const {
		reference,
		wsGroups,
		oems,
		onSaveConfiguration,
		onMultipleSaveConfiguration,
		onRemoveConfiguration,
		isPending,
		resolveGlAccounts,
	} = props;
	const title = splitCamelCaseAndUpperCase(reference);

	return (
		<>
			<Title title={title} className="!mb-[24px]" />
			<Grid container spacing={1} sx={{ width: "100%" }}>
				<>
					{oems.map((oemItem, i) => {
						return oemItem?.configuration?.map((configurationItem, j) => {
							const keyIndex = `oemItem-${reference}-${oemItem?.oemReference}-${oemItem?.dealerCodeFS}-${i}-${j}`;
							return (
								<Grid item xs={6} key={keyIndex} sx={{ width: "100%" }} className="!mb-[32px]">
									<AppendingConfigurationTable
										{...configurationItem}
										data={configurationItem.data as IRow[]}
										title={<IconContainer configurationItem={configurationItem} />}
										emptyMessage={title}
										hideGroups={false}
										hideOem={true}
										resolveGlAccounts={resolveGlAccounts}
										wsGroups={wsGroups}
										reference={reference}
										onSaveConfiguration={onSaveConfiguration}
										onMultipleSaveConfiguration={onMultipleSaveConfiguration}
										onRemoveConfiguration={onRemoveConfiguration}
										isPending={isPending}
									/>
								</Grid>
							);
						});
					})}
				</>
			</Grid>
		</>
	);
};

export default AppendingConfigFranchisesSection;
